import { ReactElement } from 'react';
import { Tooltip } from '@epam/promo';

export const WithTooltip = ({
  condition,
  text,
  children,
}: {
  condition: boolean;
  text: string;
  children: ReactElement;
}) =>
  condition ? (
    <Tooltip color="gray" content={text} placement="top">
      {children}
    </Tooltip>
  ) : (
    children
  );
